<template>
    <el-dialog :title="msg('导出关键字')" :visible.sync="visible" width="600px">
        <el-form :model="form" label-width="100px">
            <el-form-item label="时间">
                <el-date-picker clearable 
                    v-model="form.createTime" value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="关键字">
                <el-input v-model="form.keyword" type="textarea" 
                    :rows="3" 
                    placeholder="一行一个关键字，或者多个关键字用空格分隔" >
                </el-input>
            </el-form-item>
            <div style="text-align:center; margin-top: 20px;">
                <el-button type="success" size="mini" @click="onSubmit">{{msg('导出')}}</el-button>
                <el-button size="mini" v-on:click="close">{{msg('取消')}}</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>

<script>
export default {
    name: 'ExportByKeyword',
    data(){
        return {
            visible: false,
            form: {
                createTime: [],
                keyword: '',
            }
        }
    },
    methods: {
        showDialog(){
            this.form.keyword = '';
            this.form.createTime = [];
            this.visible = true;
        },
        onSubmit(){
            if(this.form.createTime.length < 2){
                this.$message.error('请选择时间');
                return;
            }
            if(this.form.keyword == ''){
                this.$message.error('请输入关键字');
                return;
            }

            let keywords = this.form.keyword.split(/\s+/).map(item => item.trim()).filter(item => item != '');
            window.open(this.$kit.api.export.exportByKeyword + "?startDate="+this.form.createTime[0]+"&endDate="+this.form.createTime[1]+"&k="+keywords.join(','));
            
            this.visible = false;
        },
        close(){
            this.visible = false;
        }   
    }
}
</script>
